import $$ from 'cmn-utils'

const baseUrl = "/api/device/event/";
export default {
    list: (params) => {
        Object.keys(params).map(key => {
            if (!params[key] || params[key] == 'null' || params[key] == 'undefined') delete params[key]
        })
        return $$.get(baseUrl + 'list', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    }
}